import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ROLE_GUARD_KEYS } from './role.constants';
import { USER_TYPES } from '../../../firestore/collections/users/users-collection.constants';
import {
  AUTH_ROUTES,
  DASHBOARD_ROUTES,
  EXERCISE_LIBRARY_ROUTES,
} from '../../../../shared/constants/routes.constants';
import { inject } from '@angular/core';
import { AuthService } from '../../auth.service';
import { catchError, concatMap, from, of } from 'rxjs';
import * as Sentry from '@sentry/angular';

export const roleGuard: CanActivateFn = (route) => {
  return checkRoles(route);
};

export const roleChildGuard: CanActivateChildFn = (childRoute) => {
  let activatedRouteSnapshot = childRoute;
  if (activatedRouteSnapshot.data[ROLE_GUARD_KEYS.ROLES] === undefined) {
    activatedRouteSnapshot = activatedRouteSnapshot.parent!;
  }

  return checkRoles(activatedRouteSnapshot);
}

function checkRoles(route: ActivatedRouteSnapshot) {
  const router = inject(Router);
  const authService = inject(AuthService);
  return from(authService.getUserType()).pipe(
    concatMap((userType) => {
      if (!userType) return from(router.navigate(AUTH_ROUTES.ROUTER_LINK.SIGN_IN));

      const allowedRoles = route.data[ROLE_GUARD_KEYS.ROLES] as string[] | undefined;
      const isAllowed = allowedRoles?.includes(userType);

      if (allowedRoles === undefined) {
        throw new Error(`RoleGuard: ${ROLE_GUARD_KEYS.ROLES} is not defined`);
      }

      if (isAllowed) return of(true);
      else if (userType === USER_TYPES.SUPPORT) {
        return from(router.navigate(EXERCISE_LIBRARY_ROUTES.ROUTER_LINK.LIST));
      } else return from(router.navigate(DASHBOARD_ROUTES.ROUTER_LINK.DASHBOARD));
    }),
    catchError((error) => {
      console.error(error);
      Sentry.captureException(error);
      return of(false);
    }),
  );
}
